Monitoring.Models.SocialContents ||= {}

class Monitoring.Models.SocialContents.YoutubeVideoContent

  constructor: (video, youtubeIntegrationId, isListening) ->
    @video = video
    @youtubeIntegrationId = youtubeIntegrationId
    @isListening = isListening

  getVideo: ->
    @video

  getIsListening: ->
    @isListening

  getYoutubeIntegrationId: ->
    @youtubeIntegrationId

  getGroupType: ->
    'youtube'

  getType: ->
    'youtube'

  getSubType: ->
    'yt-video'

  getPrivacy: ->
    'private'

  getMainText: ->
    @video.title + '-' + @video.description

  getTitle: ->
    @video.title

  getDescription: ->
    @video.description

  getContentId: ->
    @video.id

  getCreatedAt: ->
    @video.publishedAt

  getAuthorId: ->
    @video.channelId

  getAuthorUsername: ->
    ''

  getAuthorName: ->
    @video.channelName

  getAvatar: ->
    @video.channelThumbnail || window.image_path('anonymous.png')

  getParentId: ->
    null

  getBrandContent: ->
    true

  getIsPrivate: ->
    false

  getLink: ->
    "https:\/\/youtube.com\/watch?v=#{@getContentId()}#{@_getVideoOptions()}"

  contentUrl: ->
    "https:\/\/youtube.com\/watch?v=#{@getContentId()}"

  _getVideoOptions: ->
    "?controls=2&showinfo=1&rel=0&modestbranding=0&mute=1&autoplay=1"

  getYtVideo: ->
    true

  hasUser: ->
    true

  hasProfile: ->
    true

  hasRelated: ->
    true

  getVideoThumbnail: ->
    thumbnailUrl = ''
    if @video.thumbnailUrlStandardRes
      thumbnailUrl = @video.thumbnailUrlStandardRes
    else
      if @video.thumbnailUrlMediumRes
        thumbnailUrl = @video.thumbnailUrlMediumRes
      else
        thumbnailUrl = @video.rawData.snippet.thumbnails.default?.url
    if !thumbnailUrl
      thumbnailUrl = ''
    thumbnailUrl
